import { createSlice } from "@reduxjs/toolkit";

import { DEFAUT_VALUEE_FILTERS } from "../../../../../components/common/Modal/ArchiveOrderFiltersModal/constants";
import { DateFns } from "../../../../../utils/DateFns";
import { Archive, ReduxReducer } from "../../interface";

import { State } from "./interface";

const baseDateFns = new DateFns();

const DEFAULT_PAGINATION = {
	limit: undefined,
	count: 0,
	offset: 0,
};

const initialState: State = {
	pagination: DEFAULT_PAGINATION,
	filter: {
		dateFrom: baseDateFns.startDate(),
		dateTo: baseDateFns.endDate(),
		searchQuery: "",
		companyFilter: ["all"],
		taxiServiceFilter: ["all"],
	},
	internalDateRange: {
		from: baseDateFns.startDate(),
		to: baseDateFns.endDate(),
	},
	orders: {
		orderId: null,
	},
	byMultyFilters: DEFAUT_VALUEE_FILTERS,
};

const setPagination: ReduxReducer<State, State["pagination"]> = (
	state,
	{ payload },
) => {
	state.pagination = payload;
};

const setFilter: ReduxReducer<State, State["filter"]> = (
	state,
	{ payload },
) => {
	state.filter = payload;
};
const modifyPagination: ReduxReducer<State, Partial<State["pagination"]>> = (
	state,
	{ payload },
) => {
	state.pagination = { ...state.pagination, ...payload };
};

const modifyFilter: ReduxReducer<State, Partial<State["filter"]>> = (
	state,
	{ payload },
) => {
	state.filter = { ...state.filter, ...payload };
};

const modifyOrdersFilter: ReduxReducer<State, Partial<State["orders"]>> = (
	state,
	{ payload },
) => {
	state.orders = { ...state.orders, ...payload };
};

const modifyInternalDateRange: ReduxReducer<
	State,
	Partial<State["internalDateRange"]>
> = (state, { payload }) => {
	state.internalDateRange = {
		...state.internalDateRange,
		...payload,
	};
};

const resetFilter: ReduxReducer<State, any> = (state) => {
	Object.keys(initialState).forEach((key) => {
		state[key] = initialState[key];
	});
};

const setFiltersByMultyFilters: ReduxReducer<State, State["byMultyFilters"]> = (
	state,
	{ payload },
) => {
	state.byMultyFilters = payload;
};

const archiveOrdersFilters = createSlice({
	name: Archive.ConstantOrderSlice.ORDERS_FILTERS,
	initialState,
	reducers: {
		resetFilter,
		setPagination,
		setFilter,
		modifyFilter,
		modifyPagination,
		modifyInternalDateRange,
		modifyOrdersFilter,
		setFiltersByMultyFilters,
	},
});

export const archiveOrdersFiltersAction = archiveOrdersFilters.actions;
export const archiveOrdersFiltersReducer = archiveOrdersFilters.reducer;
export type archiveOrdersFiltersState = State;

export default archiveOrdersFilters;
